import React, { useEffect, useState, useCallback, useMemo, useRef } from "react";
import { LoadingOutlined, QuestionCircleOutlined, UploadOutlined, DownOutlined, AppstoreAddOutlined, PlusOutlined, DeleteOutlined, ArrowLeftOutlined, RetweetOutlined } from "@ant-design/icons";
import { useQuery } from "react-query";
import { Spin, Breadcrumb, Button, Popover, Dropdown, Space, Input, Menu, Layout, Row, Col, Form, message, Upload, Tooltip, Modal, Empty } from "antd";
import CustomerMainLayout from "../CustomerComponents/CustomerMainLayout";
import ActivityAndExploreSection from "./ActivityAndExploreSection";
import ProductSelectionModal from "./ProductSelectionModal"
import CreateProductModal from "./CreateProductModal"
import OnboardingTourModal from "../../OnboardingTour/OnboardingTourModal";
import BulkUploadModal from "./BulkUploadModal";
import { THUMBNAIL_URL, WALMART_COMPANY_ID } from "../../../environments/env";
import ENVIRONMENT from "../../../environments";
import * as Utilities from '../../App/Utilities';
import pako from "pako";
import sanitizeFilename from "../../../utils/sanitizeFilename";


import axios from "axios";
import AIGridOverlay from "./AIGridOverlay";
import "./index.scss";

import * as Constants from "../CustomerComponents/Constants";
import TwoDImagesModal from "../CustomerComponents/TwoDImagesPage/TwoDImagesModal";
import { dummyAIgeneratedImages } from "./DummyConstants";
import { setCookie, getCookie } from "../Utilities";
import posthog from "posthog-js";

import SubscriptionUpgradeManager from "../CustomerComponents/SubscriptionUpgradeManager/SubscriptionUpgradeManager";

const { Content } = Layout;
const {Dragger} = Upload
const TextArea = Input;


let CUSTOMER_USERNAME = localStorage.getItem("username");
let COMPANY_ID = localStorage.getItem('company_id')

const OrientationIcons = {
  Square: (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="2" y="2" width="10" height="10" rx="1" stroke="currentColor" strokeWidth="1.5"/>
    </svg>
  ),
  Landscape: (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="1" y="3.5" width="12" height="7" rx="1" stroke="currentColor" strokeWidth="1.5"/>
    </svg>
  ),
  Portrait: (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="3.5" y="1" width="7" height="12" rx="1" stroke="currentColor" strokeWidth="1.5"/>
    </svg>
  )
};

const AssetCreateOptions = (props) => {
  // Helper function to determine image orientation
  const getImageOrientation = (aspectRatio) => {
    if (!aspectRatio) return 'Square';
    if (aspectRatio == '16:9') return 'Landscape';
    if (aspectRatio == '9:16') return 'Portrait';
    return 'Square';
  };

  const [orientation, setOrientation] = useState('Square');
  const [orientationPopoverOpen, setOrientationPopoverOpen] = useState(false);
  const [modelLoader, setModelLoader] = useState(false)
  const [draggerOpened, setDraggerOpened] = useState(false)
  const [modelGenerationLoader, setModelGenerationLoader] = useState(false)
  const [filesList, setFilesList] = useState([])
  const [filesListRef, setFilesListRef] = useState([])
  const [selectedUnit, setSelectedUnit] = useState("inches");
  const [lifestylePrompt, setLifestylePrompt] = useState(props.previousImgPrompt);
  const [selectedImageForLifestyle, setSelectedImageForLifetsyle] = useState(props.selectedImgUri);
  const [selectedImageForInspectionLifestyle, setSelectedImageForInspectionLifestyle] = useState(props.selectedImgInspectionUri);
  const [isLifestyleRequestLoading, setIsLifestyleRequestLoading] = useState(false);
  const [width, setWidth] = useState(null);
  const [height, setHeight] = useState(null);
  const [depth, setDepth] = useState(null);
  const [productName, setProductName] = useState('');
  const [units, setUnits] = useState(null);
  const draggerRef = useRef(null)
  const buttonRef = useRef(null);
  const inspButtonRef1 = useRef(null);
  const inspButtonRef2 = useRef(null);
  const uploadButtonRef = useRef(null);
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const [openProductModal, setOpenProductModal] = useState(false);
  const [openCreateProductModal, setOpenCreateProductModal] = useState(false);
  const [bulkUploadModalVisible, setBulkUploadModalVisible] = useState(false);
  const [perspectiveRenders, setPerspectiveRenders] = useState([])
  const [regenerateJobLoader, setRegenerateJobLoader] = useState(null)
  const [exploreSectionActiveTab, setExploreSectionActiveTab] = useState('activity')
  const [promptValue, setPromptValue] = useState('')
  const [hoveredPreviewUid, setHoveredPreviewUid] = useState(null)
  const [isInspButtonFocused, setIsInspButtonFocused] = useState(false)
  const [isInspButtonHovered, setIsInspButtonHovered] = useState(false)
  const [propsList, setPropsList] = useState([]);
  const [existingProps, setExistingProps] = useState(props.initialProps || []);
  const [existingInspirationId, setExistingInspirationId] = useState(props.initialInspirationId || null);
  const [uploadType, setUploadType] = useState('product'); // 'product', 'prop', or 'inspiration'
  const [onboardingTourVisible, setOnboardingTourVisible] = useState(false);

  const hasInspirationLibrary = Array.isArray(props.inspirationLibrary) && props.inspirationLibrary.length > 0;

  const getInchesMultiplier = (unit) => {
    if (unit === "meters") return 39.3701;
    if (unit === "centimeters") return 0.393701;
    if (unit === "millimeters") return 0.0393701;
    if (unit === "feet") return 12;
    return 1; // inches (default)
  };

  const getLibraryImageUri = (obj) => {
    return obj?.image_uri || '';
  };

  const getLibraryThumbUri = (obj) => {
    return obj?.thumbnail || obj?.image_uri || '';
  };

  const getInspirationIdentifier = (item) => {
    return String(item?.identifier || '').trim();
  };

  const getDisplayImageSrc = (uri, platform = 'aws') => {
    if (!uri) return '';
    const u = String(uri);
    if (u.startsWith('http://') || u.startsWith('https://')) return u;
    const base = ENVIRONMENT.getBaseURL(platform);
    // Avoid double-encoding already-encoded URIs (they often contain %2F).
    const suffix = u.includes('%') ? u : encodeURIComponent(u);
    return base + suffix;
  };
  
  const clearGenerateMorePrefillFromUrl = () => {
    // After submitting from a "Generate more" deep link, clear prefill params so refresh starts clean.
    // Keep only stage=options (no product/job/img/prompt/props state in URL).
    try {
      const params = new URLSearchParams(window.location.search);
      params.delete("state");
      params.delete("img");
      params.delete("prompt");
      params.delete("imgInspection");
      params.delete("inspiration_id");
      params.delete("job_id");
      params.delete("productId");
      params.delete("aiModel");
      params.delete("expanded_job_id");
      params.delete("open_product_modal");
      params.delete("open_bulk_modal");
      params.set("stage", "options");
      const newUrl = `${window.location.pathname}?${params.toString()}`;
      window.history.replaceState({}, "", newUrl);
    } catch (e) {
      // no-op
    }
  };

  const launchAiCreatorTour = (first_time = false) => {
    let demoUrl = "";
    if (first_time) {
      demoUrl = new URL(`https://app.storylane.io/demo/${ENVIRONMENT.AI_CREATOR_STORYLANE_ID_WITH_REDIRECT}`);
    } else {
      demoUrl = new URL(`https://app.storylane.io/demo/${ENVIRONMENT.AI_CREATOR_STORYLANE_ID}`);  
    }
   
    if (window.Storylane) {
      window.Storylane.Play({
        type: 'popup',
        demo_type: 'image',
        width: 2560,
        height: 1442,
        scale: '0.95',
        demo_url: demoUrl,
        padding_bottom: 'calc(56.33% + 27px)'
      });
      setCookie('ai_creator_tour_viewed', 'true', 365);
      return true;
    }
    return false;
  };

  const loadStorylineScript = () => {
    const script = document.createElement('script');
    script.src = 'https://js.storylane.io/js/v1/storylane.js';
    script.async = true;
    
    script.onload = () => {
      const hasViewedOnboardingTour = getCookie('ai_creator_onboarding_tour_completed');
      if (!hasViewedOnboardingTour) {
        setTimeout(() => {
          setOnboardingTourVisible(true);
        }, 1500);
      }
    };
    
    document.body.appendChild(script);
    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  };

  const handleOnboardingTourClose = () => {
    setOnboardingTourVisible(false);
    setCookie('ai_creator_onboarding_tour_completed', 'true', 365);
  };

  const handleOnboardingTourSkip = () => {
    setOnboardingTourVisible(false);
    setCookie('ai_creator_onboarding_tour_completed', 'true', 365);
  };

  const handleRestartOnboardingTour = () => {
    setOnboardingTourVisible(true);
  };

  const handleAiCreatorTour = () => {
    handleRestartOnboardingTour();
  };

  const menu = (
    <Menu>
      <Menu.Item onClick={() => setSelectedUnit("inches")}>inches</Menu.Item>
      <Menu.Item onClick={() => setSelectedUnit("meters")}>meters</Menu.Item>
      <Menu.Item onClick={() => setSelectedUnit("centimeters")}>centimeters</Menu.Item>
                  <Menu.Item onClick={() => setSelectedUnit("millimeters")}>millimeters</Menu.Item>
                  <Menu.Item onClick={() => setSelectedUnit("feet")}>feet</Menu.Item>
    </Menu>
  );


  const validateFile = (file) => {
    const isAllowedFormat = [
      "image/png",
      "image/jpeg",
      "image/webp",
      "image/heic",
      "image/tiff"
    ].includes(file.type);

    if (!isAllowedFormat) {
      message.error("Only .png, .jpg, .webp, .heic, and .tiff formats are allowed.");
      return false;
    }

    return true;
  };

  const uploadPropsRef = {
    ...Constants.upload_props,
    multiple: false,
    accept: ".jpg,.jpeg,.png,.tiff,.webp,.heic",
    beforeUpload: (file) => {
      return validateFile(file)
    },
    fileList: filesListRef,
    onChange(info) {
      setFilesListRef([info.file]);

      const { status } = info.file;
      console.log(info);
      if (status === "uploading") {
        // If user is uploading a new inspiration, stop reusing the previous inspiration_id.
        setExistingInspirationId(null);
        setSelectedImageForInspectionLifestyle('loading');
      } else if (status !== "uploading") {
        console.log(info.file, info.fileList);
      }
      if (status === "done") {
        setExistingInspirationId(null);
        setSelectedImageForInspectionLifestyle('test_files/' + info.file['uid'] + '/' + info.file['name']);
        message.success(`${info.file.name} file uploaded successfully.`);
      } else if (status === "error") {
        if(info.file.error.code.includes('Credentials')){
          message.error('Your session has expired. Please reload the page.')
        }
        else{
          message.error(`${info.file.name} file upload failed.`);
        }
      }
    },
    onDrop(e) {
      console.log("Dropped files", e.dataTransfer.files);
    },
  };

  useEffect(() => {
    if(props.openProductModal){
      handleProductAddOption();
    }
  }, [props.openProductModal])

  useEffect(() => {
    // Only proceed when openBulkModal is true AND the request status has finished loading
    if (!props.openBulkModal || props.requestStatusLoader || props.requestStatus === 'loading') {
      return;
    }
    
    // Check if user has credits/active subscription before opening bulk modal
    const isAllowed = props.requestStatus === "allowed" || props.requestStatus === "always_allowed";

    if (isAllowed) {
      setBulkUploadModalVisible(true);
      props.setSubscriptionUpgradeManagerModel(false);
    } else {
      setBulkUploadModalVisible(false);
      props.setCurrentRequestType('ai_model');
      props.setSubscriptionUpgradeManagerModel(true);
    }
  }, [props.openBulkModal, props.requestStatusLoader, props.requestStatus])


  const handleOpenBulkModal = () => {
    if (!props.requestStatusLoader && (props.requestStatus == "allowed" || props.requestStatus == "always_allowed")) {
      setBulkUploadModalVisible(true);
    }
    else if(!props.requestStatusLoader){
      props.setCurrentRequestType('ai_model');
      props.setSubscriptionUpgradeManagerModel(true);
    }
  }

  // Set orientation based on image dimensions in generate more flow
  useEffect(() => {
    if (props.queryParamAspectRation) {
      const detectedOrientation = getImageOrientation(props.queryParamAspectRation);
      setOrientation(detectedOrientation);
    }
  }, [props.queryParamAspectRation]);
  
  const handleClickOutside = (event) => {
    const draggerRef = uploadButtonRef;
    // Check if the click is outside the dragger
    if (draggerRef.current && !draggerRef.current.contains(event.target) && buttonRef.current && !buttonRef.current.contains(event.target)) {
      setDraggerOpened(false); // Update state when clicking outside
    }
  };

  const handleProductAddOption = () => {
    setUploadType('product');
    if (!props.requestStatusLoader && (props.requestStatus == "allowed" || props.requestStatus == "always_allowed")) {
      setOpenCreateProductModal(true);
    }
    else if(!props.requestStatusLoader){
      props.setCurrentRequestType('ai_model');
      props.setSubscriptionUpgradeManagerModel(true);
    }
  };

  const handlePropAddOption = () => {
      if ((propsList.length + existingProps.length) >= 3) {
          message.warning('Maximum 3 props allowed. Please delete an existing prop to add more.');
          return;
      }
      setUploadType('prop');
      setOpenCreateProductModal(true);
  }


  const sanitizeFiles = (files) => {
    return files.map(f => ({ ...f, name: sanitizeFilename(f.name) }));
  };

  const handleCreateProductModalOk = (data) => {
    // Handle the uploaded files and dimensions from the modal
    const sanitizedFiles = sanitizeFiles(data.files || []);
    if(uploadType === 'product'){
        setFilesList(sanitizedFiles);
        setWidth(data.dimensions.width);
        setHeight(data.dimensions.height);
        setDepth(data.dimensions.depth);
        setSelectedUnit(data.dimensions.unit);
        setProductName((data?.name || '').trim());
        setOpenCreateProductModal(false);
        props.setStage('upload_images');
    } else if (uploadType === 'prop') {
        // Prop flow: either upload a new prop OR select from library
        if (data?.source === 'library' && data?.libraryItem) {
          const lib = data.libraryItem;
          const imageUri = getLibraryImageUri(lib);
          if (!imageUri) {
            message.error('Selected library prop is missing image URI.');
            return;
          }
          const newExistingProp = {
            id: lib?.id,
            image_uri: imageUri,
            // Library props already have their own dimensions (if backend provides them).
            height: lib?.height ?? null,
            width: lib?.width ?? null,
            depth: lib?.depth ?? null,
          };
          // Prevent duplicates by id when available
          setExistingProps((prev) => {
            const prevArr = prev || [];
            if (newExistingProp?.id != null && prevArr.some(p => String(p?.id) === String(newExistingProp.id))) {
              return prevArr;
            }
            return [...prevArr, newExistingProp];
          });
          setOpenCreateProductModal(false);
          return;
        }

        const newProp = {
          uid: Date.now(),
          files: sanitizedFiles,
          dimensions: data.dimensions
        };
        setPropsList([...propsList, newProp]);
        setOpenCreateProductModal(false);
    } else if (uploadType === 'inspiration') {
        // Inspiration flow: either upload OR select from library
        if (data?.source === 'library' && data?.libraryItem) {
          const lib = data.libraryItem;
          const inspirationUri = getLibraryImageUri(lib);
          if (!inspirationUri) {
            message.error('Selected inspiration is missing image URI.');
            return;
          }
          setFilesListRef([]); // clear any uploaded inspiration
          setSelectedImageForInspectionLifestyle('loading');
          setTimeout(() => {
            setExistingInspirationId(lib?.id || null);
            setSelectedImageForInspectionLifestyle(inspirationUri);
          }, 500);
          setOpenCreateProductModal(false);
          return;
        }
        // Upload flow for inspiration
        setFilesListRef(sanitizedFiles);
        setExistingInspirationId(null); // Clear existing inspiration ID when uploading new
        setSelectedImageForInspectionLifestyle('test_files/' + sanitizedFiles[0].uid + '/' + sanitizedFiles[0].name);
        setOpenCreateProductModal(false);
    }
  };

  const handleCreateProductModalCancel = () => {
    setOpenCreateProductModal(false);
  };

  const handleFormSubmit = () => {

    posthog.capture("Generate clicked", {
        source: "AI Asset Creator",
        username: localStorage.getItem('username'),
    });

    let isFormValid = true
    let errorMessage = ""

    if(filesList.length == 0){
      isFormValid = false
      errorMessage = "Upload product images to proceed."
    }
    else{
      filesList.map((item) => {
        if(item.status === "uploading"){
          isFormValid = false
          errorMessage = "Please wait for the upload(s) to complete"
        }
        else if(item.status === "error"){
          isFormValid = false
          if(item.error.code.includes('Credentials')){
            errorMessage = 'Your session has expired. Please reload the page.'
          }
          else{
            errorMessage = `${item.name} file upload failed.`
          }
        }
      })
    }
      
    if(height < 0 || width < 0 || depth < 0){
      isFormValid = false;
      errorMessage = "Product dimensions needs to be positive"
    }
    if(!isFormValid && errorMessage){
      message.error(errorMessage)
    }
    
    let values = {
      height: height,
      width: width,
      depth: depth
    }
    generateAiAssets(values)
  }

  const regnerateLifestyleJob = (jobData) => {
    
    setRegenerateJobLoader(jobData["job_id"])
    let payload = {
      "job_id": jobData["job_id"],
      "action": "regnerate_job"
    }    

    axios.post(ENVIRONMENT.AI_MODEL_HELPER, payload).then((res) => {
      props.fetchYourActivityRendersData(() => {{
        setRegenerateJobLoader(false)
      }}, false, true); // Poll silently without showing loader

    }); 

  }
 
  const handleLifeStyleRequest = () => {
    if (props.imageRequestStatus == "allowed" || props.imageRequestStatus == "always_allowed") {
      performLifeStyleRequest()
    }
    else {
      props.setCurrentRequestType('ai_image_1k');
      props.setSubscriptionUpgradeManagerModel(true);
    }
  }

  const performLifeStyleRequest = () => {
    let props_payload = propsList.map((prop) => {
      const unitMultiplier = getInchesMultiplier(prop?.dimensions?.unit);
      const firstFile = prop?.files?.[0];
      const image_url = firstFile
        ? ENVIRONMENT.getBaseURL(props.selectedProductPlatform) +
          encodeURIComponent("test_files/" + firstFile.uid + "/" + firstFile.name)
        : null;

      return {
        image_url: image_url,
        height: parseFloat(prop.dimensions.height) * unitMultiplier,
        width: parseFloat(prop.dimensions.width) * unitMultiplier,
        depth: parseFloat(prop.dimensions.depth) * unitMultiplier,
      };
    }).filter(p => p.image_url);

    // Include existing props (pre-populated from Generate more redirect state)
    const existingPropsPayload = (existingProps || [])
      .map((p) => {
        const toNumOrNull = (v) => {
          const n = parseFloat(v);
          return Number.isFinite(n) ? n : null;
        };
        const uri = p?.image_uri;
        if (!uri) return null;
        const image_url = uri.includes('https://')
          ? uri
          : ENVIRONMENT.getBaseURL(props.selectedProductPlatform) + uri;
        return {
          id: p?.id,
          image_url,
          height: toNumOrNull(p?.height),
          width: toNumOrNull(p?.width),
          depth: toNumOrNull(p?.depth),
        };
      })
      .filter(Boolean);

    props_payload = [...existingPropsPayload, ...props_payload];

    let request_payload = {
        "action": "trigger_lifestyle_generation_job",
        "aspect_ratio": orientation === "Landscape" ? "16:9" : orientation === "Portrait" ? "9:16" : "1:1",
        "product_id": props.productId,
        "job_id": props.jobId || null,
        "inspiration_id": existingInspirationId,
        "username": CUSTOMER_USERNAME,
        "prompt": lifestylePrompt.trim(),
        width: width,
        height: height,
        depth: depth,
        units: 'inches',
        "image_urls": [encodeURIComponent(selectedImageForLifestyle)],
        "company_id": COMPANY_ID || null,
        "platform": props.selectedProductPlatform,
        "asset_type": "ai_image_1k",
        "props": props_payload
    }

    if (filesListRef.length > 0) {
      request_payload.ref_url = ENVIRONMENT.getBaseURL(props.selectedProductPlatform) + "test_files/" + filesListRef[0].uid + "/" + encodeURIComponent(filesListRef[0].name)
    }
    else if(selectedImageForInspectionLifestyle){
      request_payload.ref_url = String(selectedImageForInspectionLifestyle).startsWith('http')
        ? selectedImageForInspectionLifestyle
        : (ENVIRONMENT.getBaseURL(props.selectedProductPlatform) + selectedImageForInspectionLifestyle)
    }

    console.log(JSON.stringify(request_payload))

    let gateway_payload = {
      "username": localStorage.getItem('username'),
      "request_type": "ai_image_1k",
      "action": "perform",
      "request_payload": request_payload,
      "category": "",
      "entities_per_request": 4,
      "request_id": Date.now().toString()
  }  

  console.log(JSON.stringify(gateway_payload))

    setIsLifestyleRequestLoading(true);
    axios.post(ENVIRONMENT.PAYMENT_GATEWAY, gateway_payload).then((res) => {
      props.fetchYourActivityRendersData(() => {{
          setLifestylePrompt('');
          setSelectedImageForLifetsyle('');
          setIsLifestyleRequestLoading(false);
          setExploreSectionActiveTab('activity')
          message.success('Request Submitted Successfully')
          props.setStage('options')
          clearGenerateMorePrefillFromUrl();
      }}, false, true); // Poll silently without showing loader

    });  

    // track ai flow analytics
    let aiFlowAnalyticsPayload = {
      'username': CUSTOMER_USERNAME,
      'product_id': props.productId,
      'prompt': lifestylePrompt,
      'ai_flow_state': 'Lifestyle Generation',
      'action': 'Lifestyle Generation',
      'referrer': document.referrer,
      'timestamp': new Date().toISOString(),
      'device_info': navigator.userAgent,
    }
    axios.post(ENVIRONMENT.AI_FLOW_ANALYTICS, aiFlowAnalyticsPayload)
  } 

  const handleAddInspiration = () => {
    setUploadType('inspiration');
    setOpenCreateProductModal(true);
  };

  const generateFilesUrls = () => {
    let urls = []
    for(const obj of filesList){
      urls.push(ENVIRONMENT.getBaseURL(props.selectedProductPlatform) + encodeURIComponent('test_files/' + obj.uid + '/' + obj.name))
    }
    return urls
  }

  const [bulkRequests, setBulkRequests] = useState([]);
  const bulkRequestsPollingTimeoutRef = useRef(null);
  // Track IDs that were in-progress when the page first loaded (or got added during this session)
  const trackedInProgressBulkIdsRef = useRef(new Set());
  // Track IDs that have completed during this session (used to show "complete" message)
  const [recentlyCompletedBulkRequestIds, setRecentlyCompletedBulkRequestIds] = useState(new Set());

  // Fetch bulk requests on mount and cleanup on unmount
  useEffect(() => {
    fetchUserBulkRequests();
    
    // Cleanup polling timeout on unmount
    return () => {
      if (bulkRequestsPollingTimeoutRef.current) {
        clearTimeout(bulkRequestsPollingTimeoutRef.current);
      }
    };
  }, []);

  const fetchUserBulkRequests = async () => {
    try {
      const payload = {
        action: 'get_user_bulk_request',
        username: localStorage.getItem('username')
      };
      const res = await axios.post(ENVIRONMENT.AI_BULK_JOB_CONTROLLER, payload);
      if (res.data && res.data.result === 'success') {
        const data = res.data.data || [];
        
        // Track in-progress IDs - add any new in-progress ones to our tracked set
        const currentInProgressIds = data
          .filter(req => req.status === 'inprogress')
          .map(req => req.id);
        currentInProgressIds.forEach(id => trackedInProgressBulkIdsRef.current.add(id));
        
        // Check for newly completed requests (ones that were tracked as in-progress but now are complete)
        const newlyCompletedIds = data
          .filter(req => 
            (req.status === 'completed' || req.status === 'success') && 
            trackedInProgressBulkIdsRef.current.has(req.id)
          )
          .map(req => req.id);
        
        // Add newly completed IDs to state (this will persist for the session)
        if (newlyCompletedIds.length > 0) {
          setRecentlyCompletedBulkRequestIds(prev => {
            const updated = new Set(prev);
            newlyCompletedIds.forEach(id => updated.add(id));
            return updated;
          });
        }
        
        setBulkRequests(data);
        
        // Check if there are any in-progress bulk requests
        const hasInProgressRequests = data.some(req => req.status === 'inprogress');
        
        // Clear any existing polling timeout
        if (bulkRequestsPollingTimeoutRef.current) {
          clearTimeout(bulkRequestsPollingTimeoutRef.current);
          bulkRequestsPollingTimeoutRef.current = null;
        }
        
        // Schedule next poll if there are in-progress requests (every 2 minutes)
        if (hasInProgressRequests) {
          console.log("Bulk requests polling: Scheduling next poll in 2 minutes");
          bulkRequestsPollingTimeoutRef.current = setTimeout(() => {
            fetchUserBulkRequests();
          }, 2 * 60 * 1000); // 2 minutes
        }
      }
    } catch (e) {
      console.error("Failed to fetch bulk requests", e);
    }
  };

  const handleBulkUploadSubmit = async (file, name) => {
    let file_uri = 'test_files/' + file['uid'] + '/' + file['name']
    let payload = {
      "action": "submit_bulk_job",
      "csv_file_uri": file_uri,
      "bulk_upload_name": name,
      "company_id": localStorage.getItem('company_id'),
      "customer_username": localStorage.getItem('username'),
      "request_type": "ai_lifestyle_renders"
    }
    console.log('payload = ', payload)
    
    try {
      const res = await axios.post(ENVIRONMENT.AI_BULK_JOB_CONTROLLER, payload);
      
      // Handle explicit error result
      if (res.data && res.data.result === 'error') {
        let errors = [];
        
        if (Array.isArray(res.data.errors) && res.data.errors.length > 0) {
          // Case 1: Validation errors list
          errors = res.data.errors.map((err) => ({
             row: err.row || '-', 
             message: err.message || err.error || (typeof err === 'string' ? err : JSON.stringify(err))
          }));
        } else {
          // Case 2: Generic error message (e.g. "Missing csv_file_uri")
          errors = [{ 
            row: '-', 
            message: res.data.message || 'Unknown error occurred' 
          }];
        }
        
        return { success: false, errors: errors };
      }
      
      // Success case
      setBulkUploadModalVisible(false); // Close modal
      message.success("Bulk upload submitted successfully");
      fetchUserBulkRequests(); // Refresh list
      return { success: true };

    } catch (error) {
      console.error("Bulk upload error:", error);
      return { 
        success: false, 
        errors: [{ row: '-', message: 'Network or server error occurred.' }] 
      };
    }
  }

  const generateAiAssets = (values) => {
    if (props.requestStatus == "allowed" || props.requestStatus == "always_allowed") {
      performGenerateAiAssets(values)
    }
    else {
      props.setCurrentRequestType('ai_model');
      props.setSubscriptionUpgradeManagerModel(true);
    }
  }
  
  const performGenerateAiAssets = (values) => {
    let dimensionMultiplier = 1;
    if (selectedUnit == "meters") {
      dimensionMultiplier = 39.3701;
    } else if (selectedUnit == "centimeters") {
      dimensionMultiplier = 0.393701;
    } else if (selectedUnit === "millimeters") {
      dimensionMultiplier = 0.0393701; // 1 mm = 0.0393701 inches
    } else if (selectedUnit === "feet") {
      dimensionMultiplier = 12; // 1 foot = 12 inches
    }

    let payload = {
      product_name: (productName && productName.trim().length > 0) ? productName.trim() : 'Untitled',
      brand_id: "",
      product_model_type: "product",
      dimensions: "inches",
      height: parseFloat(values.height) * dimensionMultiplier,
      width: parseFloat(values.width) * dimensionMultiplier,
      length: parseFloat(values.depth) * dimensionMultiplier,
      materials: [],
      model_status: 13,
      group_id: "",
      components: [],
      user_type: "customer",
      pantone_color: "",
      hex_color: "",
      is_configurable: false,
      need_to_model: "low_res",
      modeling_required: true,
      uploaded_model: false,
      designed_product: true,
      licensing_options: {"license": "private"},
      segmented: false,
      user_usecase: ["low_res"],
      company_id: COMPANY_ID,
      username: CUSTOMER_USERNAME,
      is_ai_model: true,
      product_photos: filesList,
      model_info: {
        height: parseFloat(values.height) * dimensionMultiplier,
        width: parseFloat(values.width) * dimensionMultiplier,
        depth: parseFloat(values.depth) * dimensionMultiplier,
      }
    }
    setModelGenerationLoader(true)
    
    // track ai flow analytics
    let aiFlowAnalyticsPayload = {
      'username': CUSTOMER_USERNAME,
      'ai_flow_state': 'AI Model Creation',
      'action': 'AI Model Creation',
      'referrer': document.referrer,
      'timestamp': new Date().toISOString(),
      'device_info': navigator.userAgent,
    }
    axios.post(ENVIRONMENT.AI_FLOW_ANALYTICS, aiFlowAnalyticsPayload)


    let metadata_extract_payload = {
      "urls": generateFilesUrls(),
      // "pid": productId  //this is to be added on the back-end
    }

    let helperPayload = {
      "action": "trigger_model_generation_job", 
      "image_urls": generateFilesUrls(), 
      // "product_id": productId,   //this is to be added on the back-end
      "height": parseFloat(values.height) * dimensionMultiplier,
      "width": parseFloat(values.width) * dimensionMultiplier,
      "depth": parseFloat(values.depth) * dimensionMultiplier,
      "units": "inches", 
      "username": CUSTOMER_USERNAME,
      "company_id": COMPANY_ID || null
    }

    let props_payload = propsList.map((prop) => {
      const unitMultiplier = getInchesMultiplier(prop?.dimensions?.unit);
      const firstFile = prop?.files?.[0];
      const image_url = firstFile
        ? ENVIRONMENT.getBaseURL(props.selectedProductPlatform) +
          encodeURIComponent("test_files/" + firstFile.uid + "/" + firstFile.name)
        : null;

      return {
        image_url: image_url,
        height: parseFloat(prop.dimensions.height) * unitMultiplier,
        width: parseFloat(prop.dimensions.width) * unitMultiplier,
        depth: parseFloat(prop.dimensions.depth) * unitMultiplier,
      };
    }).filter(p => p.image_url);

    // Include existing props (library-selected props)
    const existingPropsPayload = (existingProps || [])
      .map((p) => {
        const toNumOrNull = (v) => {
          const n = parseFloat(v);
          return Number.isFinite(n) ? n : null;
        };
        const uri = p?.image_uri;
        if (!uri) return null;
        const image_url = uri.includes('https://')
          ? uri
          : ENVIRONMENT.getBaseURL(props.selectedProductPlatform) + uri;
        return {
          id: p?.id,
          image_url,
          height: toNumOrNull(p?.height),
          width: toNumOrNull(p?.width),
          depth: toNumOrNull(p?.depth),
        };
      })
      .filter(Boolean);

    props_payload = [...existingPropsPayload, ...props_payload];

    let lifestyleGenerationPayload = {
      "action": "trigger_lifestyle_generation_job",
      "aspect_ratio": orientation === "Landscape" ? "16:9" : orientation === "Portrait" ? "9:16" : "1:1",
      // "product_id": productId,  //this is to be added on the back-end
      "username": CUSTOMER_USERNAME,
      "height": parseFloat(values.height) * dimensionMultiplier,
      "width": parseFloat(values.width) * dimensionMultiplier,
      "depth": parseFloat(values.depth) * dimensionMultiplier,
      "units": "inches", 
      "prompt": promptValue,
      "image_urls": generateFilesUrls(), 
      "company_id": COMPANY_ID || null,
      "inspiration_id": existingInspirationId,
      "props": props_payload
    }
    if (filesListRef.length > 0) {
      lifestyleGenerationPayload.ref_url = ENVIRONMENT.getBaseURL(props.selectedProductPlatform) + "test_files/" + filesListRef[0].uid + "/" + encodeURIComponent(filesListRef[0].name)
    }
    else if(selectedImageForInspectionLifestyle){
      lifestyleGenerationPayload.ref_url = String(selectedImageForInspectionLifestyle).startsWith('http')
        ? selectedImageForInspectionLifestyle
        : (ENVIRONMENT.getBaseURL(props.selectedProductPlatform) + selectedImageForInspectionLifestyle)
    }
    console.log(lifestyleGenerationPayload)

    let aiGenerateAssetsPayload = {
      'model_create_payload': payload,
      'metadata_extract_payload': metadata_extract_payload,
      'model_generation_job_payload': helperPayload,
      'lifestyle_generation_job_payload': lifestyleGenerationPayload
    }

    console.log(JSON.stringify(aiGenerateAssetsPayload))

    let gateway_payload = {
      "username": localStorage.getItem('username'),
      "request_type": "ai_model",
      "action": "perform",
      "request_payload": aiGenerateAssetsPayload,
      "category": "",
      "entities_per_request": 4,
      "request_id": Date.now().toString()
  }  

  if(promptValue.trim() != ""){
    posthog.capture("Generate with Prompt", {
      prompt: promptValue,
      username: localStorage.getItem('username'),
    })
  }

  if(lifestyleGenerationPayload.ref_url){
    posthog.capture("Generate with Inspiration Image", {
      ref_url: lifestyleGenerationPayload.ref_url,
      username: localStorage.getItem('username'),
    })
  }

    console.log(JSON.stringify(gateway_payload))


    axios.post(ENVIRONMENT.PAYMENT_GATEWAY, gateway_payload)
        .then(res => {
            if (res.data.status!=undefined && res.data.status == 1) {
              message.success("Request Submitted")
              setModelGenerationLoader(false)
              window.location.reload();
            }
            else{
                message.error('Something went wrong');
            }
        })
        .catch(error => {
          message.error('Something went wrong with your request');
          setModelGenerationLoader(false)
        });
    return
  }

  useEffect(() => {
    // Add event listener to detect clicks outside
    document.addEventListener("click", handleClickOutside);
    // document.addEventListener("click", handleProductAddOption);

    const cleanupScript = loadStorylineScript();
    return () => {
      // Cleanup event listener
      document.removeEventListener("click", handleClickOutside);
      cleanupScript();
    };
  }, []);

  useEffect(() => {
    if(props.productId && props.stage == 'lifestyle_generation'){
      setModelLoader(true)

      if(props.aiModel){
        // Get Model details
        axios.post(ENVIRONMENT.FETCH_PRODUCT, {product_id: props.productId}).then((res) => {
          let photos = []
          if(res && res.data && res.data.product_photos){
            if(res.data.product_photos){
              photos = res.data.product_photos
            }
            else if(res.data.product_photos){
              photos = res.data.product_photos
            }
            let uris = []
            photos.map((obj) => {
              let uri = 'test_files/' + obj.uid + '/' + obj.name
              uris.push(uri)
            })

            setPerspectiveRenders(uris)
            if (uris.length  == 1) {
              //If there is just one image, it should be selected by default
              setSelectedImageForLifetsyle(uris[0])
            }

            setModelLoader(false)
            console.log('res.data - ', res.data)
            setHeight(!res.data.height ? 12 : res.data.height)
            setWidth(!res.data.width ? 12 : res.data.width)
            setDepth(!res.data.length ? 12 : res.data.length)
            props.setSelectedProductPlatform(res.data.platform)
          }
        })
      }
      else{
        axios.post(ENVIRONMENT.RENDER_PRODUCT, {product_id: props.productId}).then((res) => {
          if(res && res.data){
            setHeight(res.data.height == "" ? 12 : res.data.height )
            setWidth(res.data.width  == "" ? 12 : res.data.width)
            setDepth(res.data.depth == "" ? 12 : res.data.depth)
            props.setSelectedProductPlatform(res.data.platform)

            let uris = []
            let baseUrl = ENVIRONMENT.getBaseURL(res.data.platform)
            if(res.data && res.data['2d']){
              res.data['2d'].filter(item => !item.includes('Dimensions')).map(link => {
                let uri = link.split(baseUrl)[1]
                uris.push(uri)
              })
              setPerspectiveRenders(uris)
              if (uris.length  == 1) {
                //If there is just one image, it should be selected by default
                setSelectedImageForLifetsyle(uris[0])
              }
              setModelLoader(false)
            }
          }
        })
      }
    }
  }, [props.productId, props.stage])

  useEffect(() => {
    // track ai flow analytics
    let payload = {
      'username': CUSTOMER_USERNAME,
      'ai_flow_state': props.stage == 'options' ? 'AI Creator Page' : props.stage == 'upload_images' ? 'AI Model Creation' : 'Lifestyle Generation',
      'action': 'Navigation',
      'referrer': document.referrer,
      'timestamp': new Date().toISOString(),
      'device_info': navigator.userAgent
    }
    axios.post(ENVIRONMENT.AI_FLOW_ANALYTICS, payload)

  }, [props.stage])

  useEffect(() => {
    if (props.selectedImgInspectionUri) {
      setSelectedImageForInspectionLifestyle(props.selectedImgInspectionUri);
    }
    if (props.previousImgPrompt) {
      setLifestylePrompt(props.previousImgPrompt);
    }
  }, [props.selectedImgInspectionUri, props.previousImgPrompt])

  return (
    <Content className="ai-background-container">
      <Row style={{padding: '0px 30px', width: '95%'}}>
        <ProductSelectionModal selectedProductId={props.productId} 
        setSelectedProductId={props.setProductId} setSelectedProductPlatform={props.setSelectedProductPlatform}
        visible={openProductModal} setStage={props.setStage}
        setOpenProductModal={setOpenProductModal} setAiModel={props.setAiModel}/>
        
        <CreateProductModal 
          visible={openCreateProductModal}
          onOk={handleCreateProductModalOk}
          onCancel={handleCreateProductModalCancel}
          mode={uploadType}
          propsLibrary={uploadType === 'inspiration' ? (props.inspirationLibrary || []) : (props.propsLibrary || [])}
          showNameField={uploadType === 'product'}
          nameFieldLabel="Product name"
          nameFieldPlaceholder="Enter product name"
          showDimensions={uploadType !== 'inspiration'}
          modalTitle={uploadType === 'inspiration' ? 'Add Inspiration' : null}
        />

        <OnboardingTourModal
          visible={onboardingTourVisible}
          onClose={handleOnboardingTourClose}
          onSkip={handleOnboardingTourSkip}
        />

        <BulkUploadModal
          visible={bulkUploadModalVisible}
          onCancel={() => setBulkUploadModalVisible(false)}
          onSubmit={handleBulkUploadSubmit}
        />

        {(props.stage == "lifestyle_generation") &&
          <Col span={24} className="mt-16" style={{borderRadius: 8, backgroundColor: 'white'}}>
            <Breadcrumb className='justify-in-start' style={{padding: 16}}>
              <ArrowLeftOutlined onClick={() => window.location.href = '/ai-asset-creator?stage=options'} className="mr-5"/>
              <Breadcrumb.Item>
                  <a className='manrope f-14' href='/ai-asset-creator?stage=options'>Create new image</a>
              </Breadcrumb.Item>
              {props.stage == "lifestyle_generation" &&
                <Breadcrumb.Item>
                    <div className='manrope f-14 black-33'>Generate more images</div>
                </Breadcrumb.Item>
              }
            </Breadcrumb>
          </Col>
        }
        {props.stage == 'options' ?
        <Col span={14} offset={5} >
          <Col span={24} className="justify-in-center">
            <h2 className="manrope f-24 w-700 black-00 mt-40">Create a new image</h2>
          </Col>
          <Col span={24}>
            <div style={{ marginTop: 24, display: 'flex', alignItems: 'center', gap: '16px' }}>
              <div id='generate-options' style={{ flex: 1 }}>
                <div style={{ display: 'flex', gap: '12px' }}>
                  <div ref={buttonRef} className="blue-on-hover" style={{ padding: '9px 20px', borderRadius: '2px', backgroundColor: '#F5F5F5' }} onClick={handleProductAddOption}>
                    <svg className="ai-upload-image" xmlns="http://www.w3.org/2000/svg" width="17" height="12" viewBox="0 0 17 16" fill="black">
                      <path d="M8.78558 1.57227H7.71415C7.61891 1.57227 7.57129 1.61988 7.57129 1.71512V7.32227H2.25028C2.15504 7.32227 2.10742 7.36988 2.10742 7.46512V8.53655C2.10742 8.63179 2.15504 8.67941 2.25028 8.67941H7.57129V14.2866C7.57129 14.3818 7.61891 14.4294 7.71415 14.4294H8.78558C8.88081 14.4294 8.92843 14.3818 8.92843 14.2866V8.67941H14.2503C14.3455 8.67941 14.3931 8.63179 14.3931 8.53655V7.46512C14.3931 7.36988 14.3455 7.32227 14.2503 7.32227H8.92843V1.71512C8.92843 1.61988 8.88081 1.57227 8.78558 1.57227Z"
                        fill="currentColor"
                        fillOpacity="0.85"
                      />
                    </svg>
                    <span className="manrope f-14 w-500" style={{ paddingLeft: 4, marginRight: 4 }}>Add a product</span>
                    {props.requestStatusLoader && <LoadingOutlined />}
                  </div>

                </div>
                <Button 
                  className="generate-ai-btn font-14"
                  onClick={() => handleFormSubmit()}
                  disabled={modelGenerationLoader || ((filesListRef.length < 1) && !promptValue.trim())}
                >
                  <img src="/img/ai_creator/ai-twinkle.svg" style={{ width: '20px', height: '20px', marginRight: '8px' }} /> 
                  <span>Generate</span>
                  {modelGenerationLoader && <LoadingOutlined />}
                </Button>
              </div>
                <Tooltip title={<span className="manrope f-12 white">Help</span>}>
                    <QuestionCircleOutlined onClick={handleAiCreatorTour} style={{ fontSize: '18px', color: 'black', cursor: 'pointer' }}/>
                </Tooltip>
              </div>
          </Col>
        </Col>
        : props.stage == 'upload_images' ?
          <Col span={14} offset={5} style={{color: 'black'}}>
            <Col span={24} className="justify-in-center">
              <h2 className="manrope f-24 w-700 black-00 mt-40">Add a prompt or inspiration photo</h2>
            </Col>
            <Col span={24}>
              <div style={{ marginTop: 24 }}>
                <div id='generate-box'>
                <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap', marginBottom: '16px' }}>
                  {[...filesList, ...filesListRef].map((file) => (
                    <div
                      key={file.uid}
                      style={{
                        position: 'relative',
                        width: '132px',
                        height: '132px',
                        border: '1px solid #D9D9D9',
                        borderRadius: '8px',
                        overflow: 'hidden',
                        backgroundColor: 'white'
                      }}
                      onMouseEnter={() => setHoveredPreviewUid(file.uid)}
                      onMouseLeave={() => setHoveredPreviewUid(null)}
                    >
                      {file.status === "uploading" ? (
                        <div style={{ 
                          display: 'flex', 
                          alignItems: 'center', 
                          justifyContent: 'center', 
                          height: '100%',
                          backgroundColor: '#f5f5f5'
                        }}>
                          <Spin indicator={<LoadingOutlined spin />} style={{color: '#8C8C8C'}} size="large" />
                        </div>
                      ) : (
                        <>
                          <div style={{ width: '100%', height: '100%', overflow: 'hidden' }}>
                            <img
                              style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover'
                              }}
                              src={ENVIRONMENT.getBaseURL('aws') + encodeURIComponent("test_files" + "/" + file.uid + "/" + file.name)}
                              alt={file.name}
                            />
                          </div>
                          <Button
                            onClick={() => {
                              if (filesList.find(x => x.uid === file.uid)) {
                                setFilesList(prev => prev.filter(item => item.uid !== file.uid));
                                setFilesListRef([]);
                                props.setStage('options')
                              }
                              if (filesListRef.find && filesListRef.find(x => x.uid === file.uid)) {
                                setFilesListRef([]);
                              }
                            }}
                            style={{
                              position: 'absolute',
                              top: '8px',
                              left: '8px',
                              width: '24px',
                              height: '24px',
                              minWidth: '24px',
                              padding: '0',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              backgroundColor: '#000000',
                              borderRadius: '4px',
                              border: 'none',
                              opacity: hoveredPreviewUid === file.uid ? 1 : 0,
                              transition: 'opacity 120ms ease-in-out'
                            }}
                          >
                            <DeleteOutlined style={{ color: 'white', fontSize: '14px' }} />
                          </Button>
                        </>
                      )}
                    </div>
                  ))}
                  {propsList.length > 0 && propsList.map((prop) => (
                    <div
                      key={prop.uid}
                      style={{
                        position: 'relative',
                        width: '132px',
                        height: '132px',
                        border: '1px solid #D9D9D9',
                        borderRadius: '8px',
                        overflow: 'hidden',
                        backgroundColor: 'white'
                      }}
                    >
                      <img
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover'
                        }}
                        src={ENVIRONMENT.getBaseURL('aws') + encodeURIComponent("test_files" + "/" + prop.files[0].uid + "/" + prop.files[0].name)}
                        alt="Prop"
                      />
                      <Button
                        onClick={() => {
                          setPropsList(prev => prev.filter(p => p.uid !== prop.uid));
                        }}
                        style={{
                          position: 'absolute',
                          top: '8px',
                          left: '8px',
                          width: '24px',
                          height: '24px',
                          minWidth: '24px',
                          padding: '0',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          backgroundColor: 'rgba(0,0,0,0.6)',
                          borderRadius: '4px',
                          border: 'none',
                        }}
                      >
                        <DeleteOutlined style={{ color: 'white', fontSize: '14px' }} />
                      </Button>
                    </div>
                  ))}
                  {existingProps.length > 0 && existingProps.map((prop, idx) => (
                    <div
                      key={`existing-prop-obj-${prop?.id || idx}`}
                      style={{
                        position: 'relative',
                        width: '132px',
                        height: '132px',
                        border: '1px solid #D9D9D9',
                        borderRadius: '8px',
                        overflow: 'hidden',
                        backgroundColor: 'white'
                      }}
                    >
                      <img
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover'
                        }}
                        src={
                          prop?.image_uri?.includes('https://')
                            ? prop.image_uri
                            : ENVIRONMENT.getBaseURL(props.selectedProductPlatform) + (prop?.image_uri || '')
                        }
                        alt="Prop"
                      />
                      <Button
                        onClick={() => {
                          setExistingProps(prev => prev.filter((_, i) => i !== idx));
                        }}
                        style={{
                          position: 'absolute',
                          top: '8px',
                          left: '8px',
                          width: '24px',
                          height: '24px',
                          minWidth: '24px',
                          padding: '0',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          backgroundColor: 'rgba(0,0,0,0.6)',
                          borderRadius: '4px',
                          border: 'none',
                        }}
                      >
                        <DeleteOutlined style={{ color: 'white', fontSize: '14px' }} />
                      </Button>
                    </div>
                  ))}
                  {selectedImageForInspectionLifestyle && selectedImageForInspectionLifestyle !== 'loading' && filesListRef.length === 0 && (
                    <div
                      style={{
                        position: 'relative',
                        width: '132px',
                        height: '132px',
                        border: '1px solid #D9D9D9',
                        borderRadius: '8px',
                        overflow: 'hidden',
                        backgroundColor: 'white'
                      }}
                    >
                      <img
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover'
                        }}
                        src={getDisplayImageSrc(selectedImageForInspectionLifestyle, props.selectedProductPlatform)}
                        alt="Inspiration"
                      />
                      <Button
                        onClick={() => {
                          setSelectedImageForInspectionLifestyle(null);
                          setFilesListRef([]);
                          setExistingInspirationId(null);
                        }}
                        style={{
                          position: 'absolute',
                          top: '8px',
                          left: '8px',
                          width: '24px',
                          height: '24px',
                          minWidth: '24px',
                          padding: 0,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          backgroundColor: 'rgba(0, 0, 0, 0.6)',
                          borderRadius: '4px',
                          border: 'none',
                          cursor: 'pointer',
                          zIndex: 1
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.8)';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.6)';
                        }}
                      >
                        <DeleteOutlined style={{ color: 'white', fontSize: '14px' }} />
                      </Button>
                    </div>
                  )}
                </div>
                <div style={{marginBottom: '16px'}}>
                  <Input.TextArea
                    placeholder="Enter a short prompt..." 
                    className="dimnesion-item-input input-prompt-style"
                    value={promptValue}
                    onChange={(e) => setPromptValue(e.target.value)}
                    autoSize={{ minRows: 3, maxRows: 20 }}
                    style={{ resize: 'none', border: 'none' }}
                  />
                </div>
                <div className="justify-in-between">
                  <div className="justify-in-start">
                    <Button 
                        onClick={handlePropAddOption}
                        className="insp-img-upload-btn"
                    >
                          <img src="/img/ai_creator/cube_plus.svg" style={{ marginRight: '8px', height: '16px', width: '16px' }} /> 
                          <span className="manrope f-14 w-500">Add prop</span>
                    </Button>
                    <Button ref={inspButtonRef1}
                        onClick={handleAddInspiration}
                        className="insp-img-upload-btn ml-8"
                        onFocus={() => setIsInspButtonFocused(true)}
                        onBlur={() => setIsInspButtonFocused(false)}
                        onMouseEnter={() => setIsInspButtonHovered(true)}
                        onMouseLeave={() => setIsInspButtonHovered(false)}
                    >
                      <img src={(isInspButtonFocused || isInspButtonHovered) ? '/img/ai_creator/heart-blue.svg' : '/img/ai_creator/HeartAddOutlines.svg'} style={{ marginRight: '8px' }} /> 
                      <span className="manrope f-14 w-500">{filesListRef.length == 0 && !selectedImageForInspectionLifestyle ? "Add inspiration" : "Replace inspiration"}</span>
                    </Button>
                    <Popover
                      content={
                          <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', minWidth: '120px' }}>
                              {['Square', 'Landscape', 'Portrait'].map((type) => (
                              <div 
                                  key={type} 
                                  className="manrope f-14"
                                  style={{ 
                                  display: 'flex', 
                                  alignItems: 'center', 
                                  gap: '10px', 
                                  cursor: 'pointer',
                                  padding: '8px 12px',
                                  backgroundColor: orientation === type ? '#F0F5FF' : 'transparent',
                                  color: orientation === type ? '#276DD7' : 'black',
                                  borderRadius: '4px',
                                  fontWeight: orientation === type ? '600' : '400'
                                  }}
                                  onClick={() => {
                                      setOrientation(type);
                                      setOrientationPopoverOpen(false);
                                  }}
                                  onMouseEnter={(e) => {
                                      if (orientation !== type) e.currentTarget.style.backgroundColor = '#F5F5F5';
                                  }}
                                  onMouseLeave={(e) => {
                                      if (orientation !== type) e.currentTarget.style.backgroundColor = 'transparent';
                                  }}
                              >
                                  {OrientationIcons[type]}
                                  <span>{type}</span>
                              </div>
                              ))}
                          </div>
                      }
                      trigger="click"
                      visible={orientationPopoverOpen}
                      onVisibleChange={setOrientationPopoverOpen}
                      placement="bottom"
                    >
                      <Button
                          className="insp-img-upload-btn ml-8"
                      >
                        <span style={{ marginRight: '8px', display: 'flex', alignItems: 'center' }}>
                          {OrientationIcons[orientation]}
                        </span>
                        <span className="manrope f-14 w-500">{orientation}</span>
                        <DownOutlined style={{ fontSize: '10px', marginLeft: '6px' }} />
                      </Button>
                    </Popover>
                  </div>

                  <Tooltip 
                      title={((filesListRef.length < 1) && !selectedImageForInspectionLifestyle && !promptValue.trim()) ? "Please upload an inspiration image or Enter a prompt to continue" : ""}
                    >
                    <span style={{ display: 'inline-block' }}>
                      <Button 
                        className="generate-ai-btn font-14"
                        onClick={() => handleFormSubmit()}
                        disabled={modelGenerationLoader || ((filesListRef.length < 1) && !selectedImageForInspectionLifestyle && !promptValue.trim())}
                      >
                        <img src="/img/ai_creator/ai-twinkle.svg" style={{ width: '20px', height: '20px', marginRight: '8px' }} /> 
                        <span>Generate</span>
                        {modelGenerationLoader && <LoadingOutlined />}
                      </Button>
                    </span>
                  </Tooltip>
                </div>

              </div>
              </div>
            </Col>
          </Col>
        : props.stage == 'lifestyle_generation' && props.productId ?
          <Col span={16} offset={4}>
            <Col span={24} className="justify-in-center">
              <h2 className="manrope f-24 w-700 black-00 mt-40">Generate more images</h2>
            </Col>
            <Col span={24}>
              <div style={{ marginTop: 24 }}>
                <div id='generate-box'>
                  <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap', marginBottom: '16px' }}>
                  {modelLoader ? 
                    <div className="ai-uploaded-file-card">
                      <div className="loader">
                        <Spin indicator={<LoadingOutlined spin />} style={{color: '#8C8C8C'}} size="large" />
                      </div>
                    </div>
                    :
                      <>
                        {perspectiveRenders.map((uri) => (
                          uri === "loading" ? (
                            <div
                                style={{
                                  position: 'relative',
                                  width: '132px',
                                  height: '132px',
                                  border: '1px solid #D9D9D9',
                                  borderRadius: '8px',
                                  overflow: 'hidden',
                                  backgroundColor: 'white'
                            }}>
                              <div style={{ 
                                display: 'flex', 
                                alignItems: 'center', 
                                justifyContent: 'center', 
                                height: '100%',
                                backgroundColor: '#f5f5f5'
                              }}>
                                <Spin indicator={<LoadingOutlined spin />} style={{color: '#8C8C8C'}} size="large" />
                              </div>
                            </div>
                          ):
                          <div className={`ai-uploaded-file-card`}>
                              <img
                                className="ai-file-card-image"
                                src={
                                  ENVIRONMENT.getBaseURL(props.selectedProductPlatform) + encodeURIComponent(uri)
                                }
                              />
                          </div>
                        ))}
                        {selectedImageForInspectionLifestyle && (
                          selectedImageForInspectionLifestyle === 'loading' ? (
                            <div
                              style={{
                                position: 'relative',
                                width: '132px',
                                height: '132px',
                                border: '1px solid #D9D9D9',
                                borderRadius: '8px',
                                overflow: 'hidden',
                                backgroundColor: 'white'
                              }}
                            >
                              <div style={{ 
                                display: 'flex', 
                                alignItems: 'center', 
                                justifyContent: 'center', 
                                height: '100%',
                                backgroundColor: '#f5f5f5'
                              }}>
                                <Spin indicator={<LoadingOutlined spin />} style={{color: '#8C8C8C'}} size="large" />
                              </div>
                            </div>
                          ) : (
                            <div className={`ai-uploaded-file-card`} style={{ position: 'relative' }}>
                              <img
                                className="ai-file-card-image"
                                src={
                                  getDisplayImageSrc(selectedImageForInspectionLifestyle, props.selectedProductPlatform)
                                }
                              />
                              <Button
                                onClick={() => {
                                  setSelectedImageForInspectionLifestyle(null);
                                  setFilesListRef([]);
                                  setExistingInspirationId(null);
                                }}
                                style={{
                                  position: 'absolute',
                                  top: '8px',
                                  left: '8px',
                                  width: '24px',
                                  height: '24px',
                                  minWidth: '24px',
                                  padding: 0,
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  borderRadius: '4px',
                                  border: 'none',
                                  backgroundColor: 'rgba(0, 0, 0, 0.6)',
                                  cursor: 'pointer',
                                  zIndex: 1
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.8)';
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.6)';
                                }}
                              >
                                <DeleteOutlined style={{ color: 'white', fontSize: '14px' }} />
                              </Button>
                            </div>
                          )
                        )}
                        {propsList.length > 0 && propsList.map((prop) => (
                          <div
                            key={prop.uid}
                            style={{
                              position: 'relative',
                              width: '132px',
                              height: '132px',
                              border: '1px solid #D9D9D9',
                              borderRadius: '8px',
                              overflow: 'hidden',
                              backgroundColor: 'white'
                            }}
                          >
                            <img
                              style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover'
                              }}
                              src={ENVIRONMENT.getBaseURL('aws') + encodeURIComponent("test_files" + "/" + prop.files[0].uid + "/" + prop.files[0].name)}
                              alt="Prop"
                            />
                            <Button
                              onClick={() => {
                                setPropsList(prev => prev.filter(p => p.uid !== prop.uid));
                              }}
                              style={{
                                position: 'absolute',
                                top: '8px',
                                left: '8px',
                                width: '24px',
                                height: '24px',
                                minWidth: '24px',
                                padding: '0',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                backgroundColor: 'rgba(0,0,0,0.6)',
                                borderRadius: '4px',
                                border: 'none',
                              }}
                            >
                              <DeleteOutlined style={{ color: 'white', fontSize: '14px' }} />
                            </Button>
                          </div>
                        ))}
                        {existingProps.length > 0 && existingProps.map((prop, idx) => (
                          <div
                            key={`existing-prop-obj-${prop?.id || idx}`}
                            style={{
                              position: 'relative',
                              width: '132px',
                              height: '132px',
                              border: '1px solid #D9D9D9',
                              borderRadius: '8px',
                              overflow: 'hidden',
                              backgroundColor: 'white'
                            }}
                          >
                            <img
                              style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover'
                              }}
                              src={
                                prop?.image_uri?.includes('https://')
                                  ? prop.image_uri
                                  : ENVIRONMENT.getBaseURL(props.selectedProductPlatform) + (prop?.image_uri || '')
                              }
                              alt="Prop"
                            />
                            <Button
                              onClick={() => {
                                setExistingProps(prev => prev.filter((_, i) => i !== idx));
                              }}
                              style={{
                                position: 'absolute',
                                top: '8px',
                                left: '8px',
                                width: '24px',
                                height: '24px',
                                minWidth: '24px',
                                padding: '0',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                backgroundColor: 'rgba(0,0,0,0.6)',
                                borderRadius: '4px',
                                border: 'none',
                              }}
                            >
                              <DeleteOutlined style={{ color: 'white', fontSize: '14px' }} />
                            </Button>
                          </div>
                        ))}
                      </>
                    }
                  </div>
                  <div className={`prompt-input-container`}>
                      <Input.TextArea disabled = {isLifestyleRequestLoading}
                      autoSize={{ minRows: 2, maxRows: 10 }}
                      value={lifestylePrompt}
                      onChange={(value) => setLifestylePrompt(value.target.value) } 
                        placeholder="Enter a prompt..." 
                        className="input-prompt-style-small" 
                      />
                    </div>
                    <div className="justify-space-between w-100">
                      <div className="justify-in-start">
                        <Button 
                            onClick={handlePropAddOption}
                            className="insp-img-upload-btn"
                        >
                          <img src="/img/ai_creator/cube_plus.svg" style={{ marginRight: '8px', height: '16px', width: '16px' }} /> 
                          <span className="manrope f-14 w-500">Add prop</span>
                        </Button>
                        <Button ref={inspButtonRef2}
                            onClick={handleAddInspiration}
                            className="insp-img-upload-btn ml-8"
                        >
                          <img src="/img/ai_creator/HeartAddOutlines.svg" style={{ marginRight: '8px' }} /> 
                          <span className="manrope f-14 w-500">{filesListRef.length == 0 && !selectedImageForInspectionLifestyle ? "Add inspiration" : "Replace inspiration"}</span>
                        </Button>
                        <Popover
                          content={
                              <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', minWidth: '120px' }}>
                                  {['Square', 'Landscape', 'Portrait'].map((type) => (
                                  <div 
                                      key={type} 
                                      className="manrope f-14"
                                      style={{ 
                                      display: 'flex', 
                                      alignItems: 'center', 
                                      gap: '10px', 
                                      cursor: 'pointer',
                                      padding: '8px 12px',
                                      backgroundColor: orientation === type ? '#F0F5FF' : 'transparent',
                                      color: orientation === type ? '#276DD7' : 'black',
                                      borderRadius: '4px',
                                      fontWeight: orientation === type ? '600' : '400'
                                      }}
                                      onClick={() => {
                                          setOrientation(type);
                                          setOrientationPopoverOpen(false);
                                      }}
                                      onMouseEnter={(e) => {
                                          if (orientation !== type) e.currentTarget.style.backgroundColor = '#F5F5F5';
                                      }}
                                      onMouseLeave={(e) => {
                                          if (orientation !== type) e.currentTarget.style.backgroundColor = 'transparent';
                                      }}
                                  >
                                      {OrientationIcons[type]}
                                      <span>{type}</span>
                                  </div>
                                  ))}
                              </div>
                          }
                          trigger="click"
                          visible={orientationPopoverOpen}
                          onVisibleChange={setOrientationPopoverOpen}
                          placement="bottom"
                        >
                          <Button
                              className="insp-img-upload-btn ml-8"
                          >
                            <span style={{ marginRight: '8px', display: 'flex', alignItems: 'center' }}>
                              {OrientationIcons[orientation]}
                            </span>
                            <span className="manrope f-14 w-500">{orientation}</span>
                            <DownOutlined style={{ fontSize: '10px', marginLeft: '6px' }} />
                          </Button>
                        </Popover>
                      </div>

                    <Tooltip 
                      title={(isLifestyleRequestLoading ||
                        (lifestylePrompt.trim().length === 0 && filesListRef.length === 0 && !selectedImageForInspectionLifestyle) ||
                        filesListRef.some(file => file.status === "uploading")) ? "Please upload another inspiration image or change the prompt" : ""}
                    >
                      <span style={{ display: 'inline-block' }}>
                        <Button 
                          disabled={
                            isLifestyleRequestLoading ||
                            modelLoader ||
                            (lifestylePrompt.trim().length === 0 && filesListRef.length === 0 && !selectedImageForInspectionLifestyle) ||
                            filesListRef.some(file => file.status === "uploading")
                          }
                          className="generate-ai-btn font-14"
                          onClick={() => {
                            if(!selectedImageForLifestyle.length){
                              message.error('Please select product photo to use!')
                            }
                            else{
                              handleLifeStyleRequest()
                            }
                          }}
                        >
                          <img src="/img/ai_creator/ai-twinkle.svg" style={{ width: '20px', height: '20px', marginRight: '8px' }} /> 
                          <span>Generate</span>
                          {isLifestyleRequestLoading && <LoadingOutlined />}
                        </Button>
                      </span>
                    </Tooltip>
                  </div>

                </div>
              </div>
            </Col>
          </Col>
         :
         <></>}
      </Row>

      <ActivityAndExploreSection
        displayableImages={props.displayableImages}
        aiImagesLoading={props.aiImagesLoading}
        showModal={props.showModal}
        activity_images={props.activity_images}
        regenerateJobLoader={regenerateJobLoader}
        yourActivityLoading={props.yourActivityLoading}
        regnerateLifestyleJob={regnerateLifestyleJob}
        activeTabKey={exploreSectionActiveTab}
        setActiveTabKey={setExploreSectionActiveTab}
        expandedJobId={props.expandedJobId}
        setExpandedJobId={props.setExpandedJobId}
        bulkRequests={bulkRequests}
        recentlyCompletedBulkRequestIds={recentlyCompletedBulkRequestIds}
        fetchYourActivityRendersData={props.fetchYourActivityRendersData}
        setYourActivityRenders={props.setYourActivityRenders}
        isLoadingMoreData={props.isLoadingMoreData}
        allDataLoaded={props.allDataLoaded}
        handleLoadMore={props.handleLoadMore}
        searchQuery={props.searchQuery}
        setSearchQuery={props.setSearchQuery}
        isSearchFetchingAll={props.isSearchFetchingAll}
        allDataFetchedForSearch={props.allDataFetchedForSearch}
        fetchAllRemainingDataForSearch={props.fetchAllRemainingDataForSearch}
      />
    </Content>

  )
}

const AiAssetCreate = (props) => {  
  const query = new URLSearchParams(props.location.search);
  const stage = query.get("stage") ?? 'options';
  const productId = query.get("productId") ?? "";
  const jobId = query.get("job_id") ?? "";
  const expandedJobIdParam = query.get("expanded_job_id") ?? "";
  const compressedState = query.get("state") ?? "";
  const decodeCompressedState = (encoded) => {
    if (!encoded) return null;
    try {
      // base64url -> base64
      let b64 = encoded.replace(/-/g, "+").replace(/_/g, "/");
      while (b64.length % 4) b64 += "=";
      const binary = atob(b64);
      const bytes = new Uint8Array(binary.length);
      for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
      const jsonStr = pako.inflate(bytes, { to: "string" });
      return JSON.parse(jsonStr);
    } catch (e) {
      console.error("Failed to decode compressed state", e);
      return null;
    }
  };
  const decodedState = useMemo(() => decodeCompressedState(compressedState), [compressedState]);
  const queryParamImageUri = (query.get("img") ?? "") || (decodedState?.img ?? "");
  const queryParamAspectRation = (decodedState?.aspect_ratio ?? "1:1");
  const [queryParamPrompt, setQueryParamPrompt] = useState(
    query.get("prompt") && query.get("prompt") !== "null"
      ? query.get("prompt")
      : (decodedState?.prompt ?? "")
    )
  const [queryParamInspectionImageUri, setQueryParamInspectionImageUri] = useState(
    query.get("imgInspection") && query.get("imgInspection") !== "null"
      ? query.get("imgInspection")
      : (decodedState?.imgInspection ?? "")
  )
  
  const [queryParamInspirationId, setQueryParamInspirationId] = useState(decodedState?.inspiration_id || null);
  const [queryParamProps, setQueryParamProps] = useState(decodedState?.props || []);
  const [aiModel, setAiModel] = useState(query.get("aiModel")?.toLocaleLowerCase() == 'true' ? true : false)
  const openProductModalParam = query.get("open_product_modal")?.toLowerCase() === 'true';
  const openBulkModalParam = query.get("open_bulk_modal")?.toLowerCase() === 'true';
  
  // Remove open_product_modal and open_bulk_modal parameters from URL after reading it
  useEffect(() => {
    console.log('decodeCompressedState', decodedState)
    if (query.has("open_product_modal") || query.has("open_bulk_modal")) {
      query.delete("open_product_modal");
      query.delete("open_bulk_modal");
      const newSearch = query.toString();
      const newUrl = `${window.location.pathname}${newSearch ? `?${newSearch}` : ''}`;
      window.history.replaceState({}, '', newUrl);
    }
  }, []); // Empty dependency array ensures this runs only once on mount
  
  const [assetGenerationStage, setAssetGenerationStage] = useState(stage);
  const [expandedJobId, setExpandedJobId] = useState(expandedJobIdParam);
  const [filesList, setFilesList] = useState([])
  const [isModalVisible, setisModalVisible] = useState(false);
  const [selectedImage, setSelectedImage] = useState({});
  const [imgIndex, setImgIndex] = useState(-1);
  const [deleteModal, setDeleteModal] = useState();
  const [deleteLoader, setDeleteLoader] = useState(false);
  const [libraryProductId, setLibraryProductId] = useState(productId);
  const [selectedProductPlatform, setSelectedProductPlatform] = useState('aws')
  const [imagesCount, setImagesCount] = useState({
    all: 0,
    silo: 0,
    lifestyle: 0,
    spin_360: 0,
    mp4: 0,
    favourites: 0,
    ai: 0,
  });
  const [imageType, setImageType] = useState("ai");
  const [yourActivityRenders, setYourActivityRenders] = useState([]);
  const [yourActivityLoading, setYourActivityLoading] = useState(true);
  const [requestStatus, setRequestStatus] = useState('loading');
  const [imageRequestStatus, setImageRequestStatus] = useState('loading');
  const [subscriptionUpgradeManagerModel, setSubscriptionUpgradeManagerModel] = useState(false)
  const [currentRequestType, setCurrentRequestType] = useState('ai_model')
  const [cardStatus, setCardStatus] = useState(0)
  const [requestStatusLoader, setRequestStatusLoader] = useState(true)
  const [openProductModal, setOpenProductModal] = useState(false)

  // Props/Inspiration libraries (used for "Select from Library" flows)
  const [propsLibrary, setPropsLibrary] = useState([]);
  const [inspirationLibrary, setInspirationLibrary] = useState([]);
  const [librariesLoading, setLibrariesLoading] = useState(false);
  
  // Pagination states
  const pageSize = 20;
  const [offset, setOffset] = useState(0);
  const [isLoadingMoreData, setIsLoadingMoreData] = useState(false);
  const [allDataLoaded, setAllDataLoaded] = useState(false);
  
  // Search states
  const [searchQuery, setSearchQuery] = useState('');
  const [isSearchFetchingAll, setIsSearchFetchingAll] = useState(false);
  const [allDataFetchedForSearch, setAllDataFetchedForSearch] = useState(false);


  const fetchLibraries = useCallback(() => {
    try {
      const username = localStorage.getItem("username");
      const companyId = localStorage.getItem("company_id");
      if (!username || !companyId) return;

      setLibrariesLoading(true);
      const inspirationsPayload = {
        action: "get_all_inspirations",
        username,
        company_id: parseInt(companyId, 10)
      };
      const propsPayload = {
        action: "get_all_props",
        username,
        company_id: parseInt(companyId, 10)
      };

      Promise.all([
        axios.post(ENVIRONMENT.AI_ASSETS_HELPER, inspirationsPayload),
        axios.post(ENVIRONMENT.AI_ASSETS_HELPER, propsPayload),
      ])
        .then(([inspRes, propsRes]) => {
          const insp = inspRes?.data;
          const plib = propsRes?.data;
          setInspirationLibrary(Array.isArray(insp) ? insp : (insp?.data || insp?.items || []));
          setPropsLibrary(Array.isArray(plib) ? plib : (plib?.data || plib?.items || []));
        })
        .catch(() => {
          // Silent fail: UI will just not show library CTAs.
        })
        .finally(() => {
          setLibrariesLoading(false);
        });
    } catch (e) {
      // no-op
    }
  }, []);


  useEffect(() => {
    loadUserRequestStatus();
    fetchLibraries();

    // Update global variables with current localStorage values after component mounts
    CUSTOMER_USERNAME = localStorage.getItem("username");
    COMPANY_ID = localStorage.getItem('company_id');

    //Add Google Analytics Tags
    if (window.location.hostname !== "app.all3d.ai" && window.location.hostname !== "d1v6a0zmc8r81.cloudfront.net") return; // Load GTM only on production
    const script = document.createElement("script");
    
    script.innerHTML = `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','GTM-PZWBHPCS');`;
    document.head.appendChild(script);
    
    const noscript = document.createElement("noscript");
    noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-PZWBHPCS"
    height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
    document.body.appendChild(noscript);
    return () => {
      document.head.removeChild(script);
      document.body.removeChild(noscript);
    };
  }, []);


  // Legacy fallback: Get the inspiration image and prompt from the API ONLY when not coming via compressed state.
  // Important: do not overwrite state-provided inspiration when prompt is intentionally empty.
  useEffect(() => {
    if (!productId || stage !== 'lifestyle_generation') return;
    // If we arrived via compressed state, trust it (it already includes latest inspiration/props/prompt).
    if (compressedState) return;

    const needsInspection = !queryParamInspectionImageUri;
    const needsPrompt = !queryParamPrompt;
    if (!needsInspection && !needsPrompt) return;

    const payload = {
      action: "get_ai_assets",
      product_id: productId,
      username: CUSTOMER_USERNAME,
      company_id: COMPANY_ID || null,
    };
    // If present, scope to the job_id so we fetch latest job-specific prompt/inspiration.
    if (jobId) payload.job_id = jobId;

    axios.post(ENVIRONMENT.AI_ASSETS_HELPER, payload).then((res) => {
      const insp = res?.data?.inspiration_image_uri;
      const prompt = res?.data?.prompt_text;
      if (needsInspection && insp) setQueryParamInspectionImageUri(insp);
      if (needsPrompt && prompt) setQueryParamPrompt(prompt);
    });
  }, [productId, stage, compressedState]);

  const loadUserRequestStatus = () => {
    // Check AI model request status
    let modelPayload = {
      "username": localStorage.getItem('username'),
      "request_type": "ai_model",
      "action": "check",
      "entities_per_request": 4,
      "category": ""
    }
    axios.post(ENVIRONMENT.PAYMENT_GATEWAY, modelPayload)
        .then(res => {
            console.log('Model request status:', res.data)
            setRequestStatus(res.data['request_allowed']);
            setCardStatus(res.data['card_status'])
            setRequestStatusLoader(false)
            if(openProductModalParam){
              setOpenProductModal(true);
            }
        });

    // Check AI image request status
    let imagePayload = {
      "username": localStorage.getItem('username'),
      "request_type": "ai_image_1k",
      "action": "check",
      "category": ""
    }
    axios.post(ENVIRONMENT.PAYMENT_GATEWAY, imagePayload)
        .then(res => {
            console.log('Image request status:', res.data)
            setImageRequestStatus(res.data['request_allowed']);
        });
  }

  const calculateCount = (array) => {
    // Initialize counts for each category
    const counts = array.reduce(
      (counts, image) => {
        if (image.image_type === "silo") counts.silo++;
        if (image.image_type === "lifestyle") counts.lifestyle++;
        if (image.image_type === "spin_360") counts.spin_360++;
        if (image.image_type === "mp4") counts.mp4++;
        if (image.image_type === "ai") counts.ai++;
        if (image.isFavourite) counts.favourites++; // Count favourites if `isFavourite` is true
        counts.all++; // Increment total count

        return counts;
      },
      {
        all: 0,
        silo: 0,
        lifestyle: 0,
        spin_360: 0,
        mp4: 0,
        favourites: 0,
        ai: 0,
      }
    );

    // Set the state with the final counts
    setImagesCount(counts); // Assuming setImagesCount is already available in the scope
  };

  const handleOk = () => {
    setisModalVisible(false);
  };

  const handleCancel = () => {
    setisModalVisible(false);
  };

  const handleDeleteClick = (image, imgIndex) => {
    setDeleteModal(image);
    if (imgIndex) setImgIndex(imgIndex);
  };

  
  const aiGeneratedImagesPayload = useMemo(
    () => ({
      customer_username: CUSTOMER_USERNAME,
    }),
    [CUSTOMER_USERNAME]
  );
  const {
    data: aiGeneratedImages,
    refetch: aiImagesRefetech,
    isLoading: aiImagesLoading,
  } = useQuery(
    [`${ENVIRONMENT.AI_GENERATED_IMAGES}`, aiGeneratedImagesPayload],
    () => aiGeneratedRenders(aiGeneratedImagesPayload),
    {
      enabled: !!aiGeneratedImagesPayload,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
    }
  );

  const aiGeneratedRenders = useCallback((payload) => {
    // return axios.post(ENVIRONMENT.AI_GENERATED_IMAGES, payload).then((res) => {
    //   return res.data.map((img) => {
    //     return {
    //       ...img,
    //       image_type: "ai",
    //       is360: img.threesixty_frames !== undefined,
    //       entity_id: img.product_id,
    //       platform: img.platform,
    //       entity_type: "product",
    //       image_name: img.id.toString() + ".jpg",
    //       threesixty_frames: img.threesixty_frames !== undefined ? img.threesixty_frames.data : null,
    //     };
    //   });
    // });
    return dummyAIgeneratedImages
    
  }, []);

  const updateOffset = (currentOffset) => {
    let newOffset = currentOffset + pageSize;
    setOffset(newOffset);
  };

  const fetchYourActivityRendersData = (callback = null, isInitialLoad = false, isPolling = false) => {
    // For polling, fetch all currently displayed items to check for status updates
    const currentItemsCount = yourActivityRenders.length || pageSize;
    
    const payload = {
        username: CUSTOMER_USERNAME,
        action: 'get_ai_assets_by_user_v2',
        compress_response: true,
        limit: isPolling ? currentItemsCount : pageSize,
        offset: (isInitialLoad || isPolling) ? 0 : offset
    };
    
    // Only show loaders when NOT polling
    if (!isPolling) {
      if (isInitialLoad) {
        setYourActivityLoading(true);
        setOffset(0);
      } else {
        setIsLoadingMoreData(true);
      }
    }
    
    axios.post(ENVIRONMENT.AI_MODEL_HELPER, payload).then((res) => {
      let jsonData = {}
      if(res.data.isBase64Encoded){
        jsonData = Utilities.decompressData(res);
      } 
      else{
        jsonData = res.data;
      }
      console.log("jsonData", jsonData)
      
      // Check if we received less data than requested, meaning all data is loaded
      if (!jsonData || jsonData.length === 0) {
        if (!isPolling) {
          setAllDataLoaded(true);
          setIsLoadingMoreData(false);
          setYourActivityLoading(false);
        }
        return;
      }

      if (jsonData.length < pageSize && !isPolling) {
        setAllDataLoaded(true);
      }
      
      if (isInitialLoad || isPolling) {
        // Replace data for initial load or polling (silent refresh)
        setYourActivityRenders(jsonData);
        if (isInitialLoad) {
          updateOffset(0);
        }
      } else {
        // Append data for load more
        setYourActivityRenders(prevRenders => [...prevRenders, ...jsonData]);
        updateOffset(offset);
      }
      
      if (!isPolling) {
        setYourActivityLoading(false);
        setIsLoadingMoreData(false);
      }
      
      // Check if there are in-progress items and schedule next poll
      if (jsonData.some(item => (item.status === 'inprogress') || (item.latest_status === 'inprogress') || (item.status === 'completed' && item.renders.length === 0))) {
        setTimeout(() => {
          console.log("API needs to be called again")
          fetchYourActivityRendersData(null, false, true); // Poll silently without showing loader
        }, 10000); // 10 seconds delay
      }

      if (callback != null) {
        callback()
      }
    });
  };

  // Fetch all remaining data in batches for search
  const fetchAllRemainingDataForSearch = async () => {
    if (allDataFetchedForSearch || isSearchFetchingAll) {
      return; // Already fetched or currently fetching
    }
    
    setIsSearchFetchingAll(true);
    
    try {
      let currentOffset = yourActivityRenders.length;
      let hasMore = true;
      
      while (hasMore) {
        const payload = {
          username: CUSTOMER_USERNAME,
          action: 'get_ai_assets_by_user_v2',
          compress_response: true,
          limit: pageSize,
          offset: currentOffset
        };
        
        const res = await axios.post(ENVIRONMENT.AI_MODEL_HELPER, payload);
        let jsonData = {};
        
        if (res.data.isBase64Encoded) {
          jsonData = Utilities.decompressData(res);
        } else {
          jsonData = res.data;
        }

        if (!jsonData || jsonData.length === 0) {
          hasMore = false;
          setAllDataFetchedForSearch(true);
          setAllDataLoaded(true);
        } else {
          // Append new data to existing data
          setYourActivityRenders(prevRenders => [...prevRenders, ...jsonData]);
          currentOffset += jsonData.length;
          
          if (jsonData.length < pageSize) {
            console.log("All data fetched for search", jsonData)
            hasMore = false;
            setAllDataFetchedForSearch(true);
            setAllDataLoaded(true);
          }
        }
      }
    } catch (error) {
      console.error('Error fetching all data for search:', error);
      message.error('Failed to fetch all data for search');
    } finally {
      setIsSearchFetchingAll(false);
    }
  };

  useEffect(() => {
    fetchYourActivityRendersData(null, true);
  }, [])

  const GetImageURL = (item, thumbnail = false, add_base_url = true) => {
    if (item.image_type == "silo") {
      if (
        item.image_status == "completed" &&
        (!("is_hidden" in item) || item.is_hidden !== true)
      ) {
        let silo_base_uri = "";
        let unique_attributer = "username";
        if (item.company_id) {
          silo_base_uri = "company/" + item.company_id;
          unique_attributer = "company";
        } else {
          silo_base_uri = item.username;
        }

        let imageUrl =
          ENVIRONMENT.getBaseURL(item["platform"]) +
          (thumbnail
            ? ENVIRONMENT.LOW_RES_QA_IMG_URI
            : ENVIRONMENT.QA_IMG_URI) +
          item["entity_id"] +
          "/" +
          silo_base_uri +
          "/" +
          item.camera_name +
          (thumbnail ? "_512" : "") +
          "." +
          item.image_format.replace("tiff", "jpg");
        return imageUrl;
      }
    }

    if (item.image_type === "ai") {
      if (item.is360) {
        let baseUrl = "";
        if (item.company_id) {
          baseUrl = "company/" + item.company_id;
        } else {
          baseUrl = item.captured_by ? item.captured_by : item.username;
        }

        let imageUrl =
          ENVIRONMENT.getBaseURL() +
          "product_assets/ai_generated_spin/" +
          `${item.product_id}/frames/` +
          item.uri;
        return imageUrl;
      }
      // Check if URI is already a full URL (like CloudFront URLs in dummy data)
      const isFullUrl = item.uri && (item.uri.startsWith('http://') || item.uri.startsWith('https://'));
      if(thumbnail){
        if (isFullUrl) {
          // For full URLs (dummy data), return as-is without _512 append
          return item.uri;
        }
        return add_base_url ? ENVIRONMENT.getBaseURL(item.platform) : '' + item.uri.replace(/(\.[^.]+)$/, "_512$1"); // add _512 before the file format to get low res url link
      }
      if (isFullUrl) {
        // For full URLs (dummy data), return as-is
        return item.uri;
      }
      return add_base_url ? ENVIRONMENT.getBaseURL(item.platform) : '' + item.uri;
    }

    if (item.image_type === "ai_generated_glb") {
      if (thumbnail) {
        return THUMBNAIL_URL + item.product_id + "_default.png" 

      }
      return ENVIRONMENT.getBaseURL(item.platform) + item.uri;
    }

    if (item.image_type == "lifestyle") {
      if (thumbnail) {
        const parts = item.filename.split(".");
        const updatedFilename =
          parts.slice(0, -1).join(".") + "_512." + parts.at(-1);
        return (
          ENVIRONMENT.getBaseURL(item.platform) +
          ENVIRONMENT.SCENE_THUMBNAIL_URI +
          item.entity_id +
          "/" +
          updatedFilename
        ).replace("tiff", "jpg");
      } else {
        return (
          ENVIRONMENT.getBaseURL(item.platform) +
          ENVIRONMENT.SCENE_THUMBNAIL_URI +
          item.entity_id +
          "/" +
          item.filename
        ).replace("tiff", "jpg");
      }
    }

    if (item.image_type == "spin_360") {
      let baseUrl = "";
      if (item.company_id) {
        baseUrl = "company/" + item.company_id;
      } else {
        baseUrl = item.captured_by ? item.captured_by : item.customer_username;
      }

      let imageUrl =
        ENVIRONMENT.getBaseURL() +
        "product_assets/threesixtys_frames/" +
        `${baseUrl}/` +
        item.spin_360_frames[0];
      return imageUrl;
    }

    if (item.image_type == "mp4") {
      let baseUrl = "";
      if (item.company_id) {
        baseUrl = "company/" + item.company_id;
      } else {
        baseUrl = item.captured_by ? item.captured_by : item.customer_username;
      }

      let imageUrl =
        ENVIRONMENT.getBaseURL() +
        "product_assets/video/" +
        `${baseUrl}/` +
        item.entity_id +
        ".mp4";
      return imageUrl;
    }
  };


  const displayableImages = useMemo(() => {
   
    const concatImg = [
    ]
    let imgs = [];
    if (aiGeneratedImages) {
      imgs = concatImg.concat(aiGeneratedImages).filter(img => img.status === "completed");
    }
    calculateCount(imgs)
    return imgs?.map((image, index) => ({
      ...image,
      orignalIndex: index,
      width: image.width,
      height: image.height,
      src: GetImageURL(image, false, true),
      thumbnail: GetImageURL(image, true, false),
      customOverlay: <AIGridOverlay obj={image} />,
    }))
    
  }, [aiGeneratedImages]);

  const showModal = useCallback((src) => {
    setSelectedImage(
      displayableImages.find((image) => image.src === src)
    );
    setisModalVisible(true);
    let index = displayableImages.findIndex((image) => image.src === src);
    setImgIndex(index);
  }, [displayableImages]); // Only re-create when `displayableImages` changes
  


  const renderDelete = (x) => {
    if (
      !x ||
      (!x.filename && !x.camera_name) ||
      x.image_type === "spin_360" ||
      x.image_type === "mp4"
    )
      return null;

    return (
      <Tooltip title={<span className="manrope f-12 white">Delete</span>}>
        <Button
          onClick={() => handleDeleteClick(x)}
          className="manrope f-14 w-500 lh-22 ai-action-btn ai-action-btn-red"
          icon={<DeleteOutlined />}
        />
      </Tooltip>
    );
  };

  const renderDownload = (src, obj) => {
    return null;

  };


  const renderGenerateHighResImage = (x) => {
    if (!x || !x.filename) return null;
  };


  const renderCollaborationTooltip = (image) => {
    if (
      image.image_type === "spin_360" ||
      image.image_type === "mp4" ||
      image.image_type === "ai"
    ) {
      return null;
    }
  };

  const renderReportButton = (x) => {
    return null
  };

  const renderFavouriteButton = (obj) => {
    if (obj.image_type === "ai") {
      return null;
    }
  }


  return (
    <>
      <CustomerMainLayout selected='26' remove_global_padding={true}>
          <AssetCreateOptions
            displayableImages={displayableImages}
            aiImagesLoading={aiImagesLoading} 
            stage={assetGenerationStage}
            setStage={setAssetGenerationStage}
            activity_images={yourActivityRenders}
            setYourActivityRenders={setYourActivityRenders}
            yourActivityLoading={yourActivityLoading}
            showModal={showModal}
            productId={libraryProductId}
            jobId={jobId}
            expandedJobId={expandedJobId}
            setExpandedJobId={(newExpandedJobId) => {
              const params = new URLSearchParams(window.location.search);
              if (newExpandedJobId) {
                params.set("expanded_job_id", newExpandedJobId);
              } else {
                params.delete("expanded_job_id");
              }
              const newUrl = `${window.location.pathname}${params.toString() ? `?${params.toString()}` : ""}`;
              window.history.replaceState({}, "", newUrl);
              setExpandedJobId(newExpandedJobId || "");
            }}
            setProductId={setLibraryProductId}
            aiModel={aiModel}
            setAiModel={setAiModel}
            fetchYourActivityRendersData={fetchYourActivityRendersData}
            selectedImgUri={queryParamImageUri}
            previousImgPrompt={queryParamPrompt}
            setSelectedProductPlatform={setSelectedProductPlatform}
            selectedProductPlatform={selectedProductPlatform}
            requestStatus={requestStatus}
            imageRequestStatus={imageRequestStatus}
            setCurrentRequestType={setCurrentRequestType}
            subscriptionUpgradeManagerModel={subscriptionUpgradeManagerModel}
            setSubscriptionUpgradeManagerModel={setSubscriptionUpgradeManagerModel}
            selectedImgInspectionUri={queryParamInspectionImageUri}
            initialInspirationId={queryParamInspirationId}
            initialProps={queryParamProps}
            inspirationLibrary={inspirationLibrary}
            propsLibrary={propsLibrary}
            requestStatusLoader={requestStatusLoader}
            isLoadingMoreData={isLoadingMoreData}
            allDataLoaded={allDataLoaded}
            openProductModal={openProductModal}
            openBulkModal={openBulkModalParam}
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            isSearchFetchingAll={isSearchFetchingAll}
            allDataFetchedForSearch={allDataFetchedForSearch}
            fetchAllRemainingDataForSearch={fetchAllRemainingDataForSearch}
            queryParamAspectRation={queryParamAspectRation}
            handleLoadMore={() => {
              if (!isLoadingMoreData && !allDataLoaded) {
                fetchYourActivityRendersData();
              }
            }}
          />
          <TwoDImagesModal
            key={isModalVisible ? "open" : "closed"}
            isVisible={isModalVisible}
            handleOk={handleOk}
            handleCancel={handleCancel}
            currentfile={selectedImage}
            filteredImages={displayableImages}
            renderDelete={renderDelete}
            renderDownload={renderDownload}
            renderGenerateHighResImage={renderGenerateHighResImage}
            setType={setImageType}
            Type={imageType}
            imagesCount={imagesCount}
            renderCollaborationTooltip={renderCollaborationTooltip}
            renderReportButton={renderReportButton}
            renderFavouriteButton={renderFavouriteButton}
            aiPage={true}
          />

          <SubscriptionUpgradeManager
            subscriptionUpgradeManagerModel={subscriptionUpgradeManagerModel}
            setSubscriptionUpgradeManagerModel={setSubscriptionUpgradeManagerModel}
            cardStatus={cardStatus}
            loadUserRequestStatus={loadUserRequestStatus}
            requestType={currentRequestType}
          />

      </CustomerMainLayout>
    </>
  );
}

export default AiAssetCreate;
